(function () {
  if (window.StenInit && window.StenInit['EC-custom-breadcrumbs']) return;
  window.StenInit = window.StenInit || {};
  window.StenInit['EC-custom-breadcrumbs'] = true;

  // Apply char-limit truncation to every trail within a scope (in-place or injected).
  function applyTruncation(scope, desktopLimit, mobileLimit) {
    scope.querySelectorAll('.EC-truncated-desktop').forEach(function (el) {
      var original = el.getAttribute('title') || el.textContent;
      el.textContent = (desktopLimit > 0 && original.length > desktopLimit)
        ? original.substring(0, desktopLimit - 3) + '...'
        : original;
    });
    scope.querySelectorAll('.EC-truncated-mobile').forEach(function (el) {
      var original = el.getAttribute('title') || el.textContent;
      el.textContent = (mobileLimit > 0 && original.length > mobileLimit)
        ? original.substring(0, mobileLimit - 3) + '...'
        : original;
    });
  }

  var liveRegionAdded = false;
  function announce(container) {
    if (liveRegionAdded) return;
    var links = container.querySelectorAll('a');
    if (!links.length) return;
    var liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
    document.body.appendChild(liveRegion);
    liveRegionAdded = true;
    setTimeout(function () {
      liveRegion.textContent = 'Breadcrumb navigation with ' + links.length + ' items loaded';
    }, 100);
  }

  // In-place render: server-rendered markup already in the DOM. Just truncate.
  function initInPlace(root) {
    if (root.dataset.stenInitialized) return;
    root.dataset.stenInitialized = 'true';
    var desktopLimit = parseInt(root.dataset.desktopCharLimit, 10) || 0;
    var mobileLimit = parseInt(root.dataset.mobileCharLimit, 10) || 0;
    applyTruncation(root, desktopLimit, mobileLimit);
    announce(root);
  }

  // Injection: clone the template into any insertion divs that exist.
  function initInject(template) {
    if (template.dataset.stenInitialized) return;
    template.dataset.stenInitialized = 'true';

    var sectionId = template.dataset.sectionId;
    var injectableClass = 'EC-breadcrumbs-injectable-' + sectionId;
    var desktopLimit = parseInt(template.dataset.desktopCharLimit, 10) || 0;
    var mobileLimit = parseInt(template.dataset.mobileCharLimit, 10) || 0;
    var customClass = template.dataset.customClass || '';

    function injectInto(selector, deviceClass) {
      var el = document.querySelector(selector);
      if (!el) return false;
      el.innerHTML = '';
      el.appendChild(template.content.cloneNode(true));
      el.className = 'EC-breadcrumbs-injectable ' + injectableClass +
        (deviceClass ? ' ' + deviceClass : '') +
        (customClass ? ' ' + customClass : '');
      applyTruncation(el, desktopLimit, mobileLimit);
      return true;
    }

    var a = injectInto('#EC-custom-breadcrumbs-block', '');
    var b = injectInto('#EC-custom-breadcrumbs-block-desktop', 'EC-bc-desktop-only');
    var c = injectInto('#EC-custom-breadcrumbs-block-mobile', 'EC-bc-mobile-only');

    if (a || b || c) {
      announce(document.querySelector('.' + injectableClass));
    }

    // Theme editor support
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.detail.sectionId === sectionId) {
          injectInto('#EC-custom-breadcrumbs-block', '');
          injectInto('#EC-custom-breadcrumbs-block-desktop', 'EC-bc-desktop-only');
          injectInto('#EC-custom-breadcrumbs-block-mobile', 'EC-bc-mobile-only');
        }
      });
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.detail.sectionId === sectionId) {
          document.querySelectorAll('.' + injectableClass).forEach(function (el) {
            el.innerHTML = '';
          });
        }
      });
      var fallback = document.querySelector('.EC-breadcrumbs-fallback-editor-only');
      if (fallback) fallback.style.display = 'block';
    }
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-section-type="EC-custom-breadcrumbs"]').forEach(initInPlace);
    scope.querySelectorAll('template[data-section-type="EC-custom-breadcrumbs-inject"]').forEach(initInject);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();